var races = [{
    "race": "Bixby City Council - Ward 4",
    "title": "Bixby City Council",
    "subheader": "Ward 4",
    "description": "",
    "precincts": 90,
    "precinctsTotal": 8,
    "precinctsReported": 8,
    "candidates": [{
        "candidatenum": 1001,
        "firstName": "BRAD",
        "lastName": "GIRARD",
        "party": "",
        "votes": 318,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 1002,
        "firstName": "JEREMY",
        "lastName": "SHADRICK",
        "party": "",
        "votes": 62,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 1003,
        "firstName": "VICTORIA",
        "lastName": "OLTMANN",
        "party": "",
        "votes": 46,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 1004,
        "firstName": "ERIC",
        "lastName": "COVEY",
        "party": "",
        "votes": 12,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 1005,
        "firstName": "AMY",
        "lastName": "LYNN THOMPSON",
        "party": "",
        "votes": 4,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 442,
    "hasWinners": true
  },
  {
    "race": "Collinsville Mayor",
    "title": "Collinsville Mayor",
    "subheader": "",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 6,
    "precinctsReported": 6,
    "candidates": [{
        "candidatenum": 2001,
        "firstName": "BUD",
        "lastName": "YORK",
        "party": "",
        "votes": 272,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 2002,
        "firstName": "JERRY",
        "lastName": "GARRETT",
        "party": "",
        "votes": 270,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 542,
    "hasWinners": true
  },
  {
    "race": "Collinsville City Council - Ward 3",
    "title": "Collinsville City Council",
    "subheader": "Ward 3",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 1,
    "precinctsReported": 1,
    "candidates": [{
        "candidatenum": 3001,
        "firstName": "LARRY",
        "lastName": "SHAFER",
        "party": "",
        "votes": 101,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 3002,
        "firstName": "LEESA",
        "lastName": "BARNETT",
        "party": "",
        "votes": 53,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 154,
    "hasWinners": true
  },
  {
    "race": "Collinsville City Council - Ward 4",
    "title": "Collinsville City Council",
    "subheader": "Ward 4",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 3,
    "precinctsReported": 3,
    "candidates": [{
        "candidatenum": 4001,
        "firstName": "JERRY",
        "lastName": "PYKIET",
        "party": "",
        "votes": 90,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 4002,
        "firstName": "JEROMY",
        "lastName": "S BURWELL",
        "party": "",
        "votes": 87,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 177,
    "hasWinners": true
  },
  {
    "race": "Sperry Schools Prop 1 - Construction",
    "title": "Sperry Schools Proposition 1",
    "subheader": "$11,170,000 Construction Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 8,
    "precinctsReported": 8,
    "candidates": [{
        "candidatenum": 5001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 259,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 5002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 66,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 325,
    "hasWinners": true
  },
  {
    "race": "Sperry Schools Prop 2 - Transportation",
    "title": "Sperry Schools Proposition 2",
    "subheader": "$960,000 Transportation Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 8,
    "precinctsReported": 8,
    "candidates": [{
        "candidatenum": 6001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 261,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 6002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 64,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 325,
    "hasWinners": true
  },
  {
    "race": "Stilwell Schools Prop - Construction",
    "title": "Stilwell Schools Proposition",
    "subheader": "$1,825,000 Construction Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 10,
    "precinctsReported": 10,
    "candidates": [{
        "candidatenum": 7001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 276,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 7002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 280,
        "incumbent": false,
        "winner": true
      }
    ],
    "votes": 556,
    "hasWinners": true
  },
  {
    "race": "Keys Schools Prop - Transportation",
    "title": "Keys Schools Proposition",
    "subheader": "$500,000 Transportation Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 4,
    "precinctsReported": 4,
    "candidates": [{
        "candidatenum": 8001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 187,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 8002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 130,
        "incumbent": false,
        "winner": true
      }
    ],
    "votes": 317,
    "hasWinners": true
  },
  {
    "race": "Mounds School Board - Office No. 3",
    "title": "Mounds School Board",
    "subheader": "Office No. 3",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 5,
    "precinctsReported": 5,
    "candidates": [{
        "candidatenum": 9001,
        "firstName": "CLAYTON",
        "lastName": "J LAMB",
        "party": "",
        "votes": 110,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 9002,
        "firstName": "CHRIS",
        "lastName": "MAC McDONALD",
        "party": "",
        "votes": 80,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 190,
    "hasWinners": true
  },
  {
    "race": "Sapulpa City Council - Ward 1, Seat 1",
    "title": "Sapulpa City Council",
    "subheader": "Ward 1 Seat 1",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 5,
    "precinctsReported": 5,
    "candidates": [{
        "candidatenum": 10001,
        "firstName": "HUGO",
        "lastName": "NAIFEH",
        "party": "",
        "votes": 76,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 10002,
        "firstName": "CHARLES",
        "lastName": "E BETZLER",
        "party": "",
        "votes": 36,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 112,
    "hasWinners": true
  },
  {
    "race": "Sapulpa City Council - Ward 2, Seat 1",
    "title": "Sapulpa City Council",
    "subheader": "Ward 2 Seat 1",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 9,
    "precinctsReported": 9,
    "candidates": [{
        "candidatenum": 11001,
        "firstName": "CHARLES",
        "lastName": "STEPHENS",
        "party": "",
        "votes": 56,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 11002,
        "firstName": "BRIAN",
        "lastName": "STEPHENS",
        "party": "",
        "votes": 31,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 87,
    "hasWinners": true
  },
  {
    "race": "Sapulpa City Council - Ward 5, Seat 1",
    "title": "Sapulpa City Council",
    "subheader": "Ward 5 Seat 1",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 7,
    "precinctsReported": 7,
    "candidates": [{
        "candidatenum": 12001,
        "firstName": "BRUCE",
        "lastName": "BLEDSOE",
        "party": "",
        "votes": 56,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 12002,
        "firstName": "ALAN",
        "lastName": "H JONES",
        "party": "",
        "votes": 43,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 99,
    "hasWinners": true
  },
  {
    "race": "Stigler Schools Prop - Construction",
    "title": "Stigler Schools Proposition",
    "subheader": "$12,290,000 Construction Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 9,
    "precinctsReported": 9,
    "candidates": [{
        "candidatenum": 13001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 915,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 13002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 940,
        "incumbent": false,
        "winner": true
      }
    ],
    "votes": 1855,
    "hasWinners": true
  },
  {
    "race": "Cameron School Board - Office No. 4",
    "title": "Cameron School Board",
    "subheader": "Office No. 4",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 4,
    "precinctsReported": 4,
    "candidates": [{
        "candidatenum": 14001,
        "firstName": "RICHARD",
        "lastName": "JOHNSON",
        "party": "",
        "votes": 94,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 14002,
        "firstName": "SHERRY",
        "lastName": "WILLIS",
        "party": "",
        "votes": 31,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 125,
    "hasWinners": true
  },
  {
    "race": "Poteau Schools Prop - Construction",
    "title": "Poteau Schools Proposition",
    "subheader": "$13,105,000 Construction Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 9,
    "precinctsReported": 9,
    "candidates": [{
        "candidatenum": 15001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 656,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 15002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 525,
        "incumbent": false,
        "winner": true
      }
    ],
    "votes": 1181,
    "hasWinners": true
  },
  {
    "race": "Salina Schools Prop 1 - Construction",
    "title": "Salina Schools Proposition 1",
    "subheader": "$3,310,000 Construction Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 5,
    "precinctsReported": 5,
    "candidates": [{
        "candidatenum": 16001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 353,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 16002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 87,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 440,
    "hasWinners": true
  },
  {
    "race": "Salina Schools Prop 2 - Transportation",
    "title": "Salina Schools Proposition 2",
    "subheader": "$685,000 Transportation Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 5,
    "precinctsReported": 5,
    "candidates": [{
        "candidatenum": 17001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 360,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 17002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 87,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 447,
    "hasWinners": true
  },
  {
    "race": "Haskell School Board - Office No. 3",
    "title": "Haskell School Board",
    "subheader": "Office No. 3",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 8,
    "precinctsReported": 8,
    "candidates": [{
        "candidatenum": 18001,
        "firstName": "CORRIE",
        "lastName": "L BUCHANAN",
        "party": "",
        "votes": 321,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 18002,
        "firstName": "LEWIS",
        "lastName": "GONZALES",
        "party": "",
        "votes": 212,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 533,
    "hasWinners": true
  },
  {
    "race": "Nowata City Commissioner - Ward 4",
    "title": "Nowata City Commissioner",
    "subheader": "Ward 4",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 2,
    "precinctsReported": 2,
    "candidates": [{
        "candidatenum": 19001,
        "firstName": "KARON",
        "lastName": "MILLER",
        "party": "",
        "votes": 16,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 19002,
        "firstName": "JOSHUA",
        "lastName": "LEE BRINKMAN",
        "party": "",
        "votes": 9,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 25,
    "hasWinners": true
  },
  {
    "race": "Okmulgee County Prop - Fire Sales Tax",
    "title": "Okmulgee County Proposition",
    "subheader": "Fire Sales Tax",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 24,
    "precinctsReported": 24,
    "candidates": [{
        "candidatenum": 20001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 1375,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 20002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 203,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 1578,
    "hasWinners": true
  },
  {
    "race": "Avant Schools Prop 1 - Construction",
    "title": "Avant Schools Proposition 1",
    "subheader": "$460,000 Construction Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 5,
    "precinctsReported": 5,
    "candidates": [{
        "candidatenum": 21001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 40,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 21002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 5,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 45,
    "hasWinners": true
  },
  {
    "race": "Avant Schools Prop 2 - Transportation",
    "title": "Avant Schools Proposition 2",
    "subheader": "$90,000 Transportation Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 5,
    "precinctsReported": 5,
    "candidates": [{
        "candidatenum": 22001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 38,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 22002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 7,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 45,
    "hasWinners": true
  },
  {
    "race": "Barnsdall Schools Prop - Construction",
    "title": "Barnsdall Schools Proposition",
    "subheader": "$6,325,000 Construction Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 4,
    "precinctsReported": 4,
    "candidates": [{
        "candidatenum": 23001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 313,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 23002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 114,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 427,
    "hasWinners": true
  },
  {
    "race": "Pawhuska School Board - Office No. 3",
    "title": "Pawhuska School Board",
    "subheader": "Office No. 3",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 8,
    "precinctsReported": 8,
    "candidates": [{
        "candidatenum": 24001,
        "firstName": "DANNY",
        "lastName": "FERGUSON",
        "party": "",
        "votes": 332,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 24002,
        "firstName": "SCOTT",
        "lastName": "LAIRD",
        "party": "",
        "votes": 364,
        "incumbent": false,
        "winner": true
      }
    ],
    "votes": 696,
    "hasWinners": true
  },
  {
    "race": "Fairland Schools Prop - Construction",
    "title": "Fairland Schools Proposition",
    "subheader": "$3,620,000 Construction Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 1,
    "precinctsReported": 1,
    "candidates": [{
        "candidatenum": 25001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 196,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 25002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 192,
        "incumbent": false,
        "winner": true
      }
    ],
    "votes": 388,
    "hasWinners": true
  },
  {
    "race": "Miami City Council - Ward 3",
    "title": "Miami City Council",
    "subheader": "Ward 3",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 4,
    "precinctsReported": 4,
    "candidates": [{
        "candidatenum": 26001,
        "firstName": "RYAN",
        "lastName": "ORCUTT",
        "party": "",
        "votes": 131,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 26002,
        "firstName": "NEAL",
        "lastName": "JOHNSON",
        "party": "",
        "votes": 93,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 224,
    "hasWinners": true
  },
  {
    "race": "Hartshone Mayor (Unexpired Term)",
    "title": "Hartshone Mayor",
    "subheader": "(Unexpired Term)",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 4,
    "precinctsReported": 4,
    "candidates": [{
        "candidatenum": 27001,
        "firstName": "JOY",
        "lastName": "F CLINE",
        "party": "",
        "votes": 158,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 27002,
        "firstName": "BENNETT",
        "lastName": "W NELSON",
        "party": "",
        "votes": 70,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 228,
    "hasWinners": true
  },
  {
    "race": "McAlester City Council - Ward 6",
    "title": "McAlester City Council",
    "subheader": "Ward 6",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 8,
    "precinctsReported": 8,
    "candidates": [{
        "candidatenum": 28001,
        "firstName": "DANNY",
        "lastName": "R GIACOMO",
        "party": "",
        "votes": 81,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 28002,
        "firstName": "ZACH",
        "lastName": "PRICHARD",
        "party": "",
        "votes": 80,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 28003,
        "firstName": "DaMARIA",
        "lastName": "MADDOX",
        "party": "",
        "votes": 46,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 207,
    "hasWinners": true
  },
  {
    "race": "McAlester School Board - Office No. 3",
    "title": "McAlester School Board",
    "subheader": "Office No. 3",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 19,
    "precinctsReported": 19,
    "candidates": [{
        "candidatenum": 29001,
        "firstName": "JOY",
        "lastName": "TRIBBEY",
        "party": "",
        "votes": 513,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 29002,
        "firstName": "BRENDA",
        "lastName": "CALAHAN",
        "party": "",
        "votes": 352,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 865,
    "hasWinners": true
  },
  {
    "race": "Northwest Fire Prop 1 - Fire Truck Purchase",
    "title": "Northwest Fire Proposition 1",
    "subheader": "$3,000,000 Truck Purchase Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 11,
    "precinctsReported": 11,
    "candidates": [{
        "candidatenum": 30001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 748,
        "incumbent": false,
        "winner": true
      },
      {
        "candidatenum": 30002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 433,
        "incumbent": false,
        "winner": false
      }
    ],
    "votes": 1181,
    "hasWinners": true
  },
  {
    "race": "Northwest Fire Prop 2 - Construction",
    "title": "Northwest Fire Proposition 2",
    "subheader": "$7,500,000 Construction Bond",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 11,
    "precinctsReported": 11,
    "candidates": [{
        "candidatenum": 31001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 310,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 31002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 867,
        "incumbent": false,
        "winner": true
      }
    ],
    "votes": 1177,
    "hasWinners": true
  },
  {
    "race": "City of Wagoner Prop 1 - Marshal Appointment",
    "title": "City of Wagoner Proposition 1",
    "subheader": "Marshal Appointment",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 3,
    "precinctsReported": 3,
    "candidates": [{
        "candidatenum": 32001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 133,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 32002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 862,
        "incumbent": false,
        "winner": true
      }
    ],
    "votes": 995,
    "hasWinners": true
  },
  {
    "race": "City of Wagoner Prop 2 - Clerk Appointment",
    "title": "City of Wagoner Proposition 2",
    "subheader": "Clerk Appointment",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 3,
    "precinctsReported": 3,
    "candidates": [{
        "candidatenum": 33001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 141,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 33002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 853,
        "incumbent": false,
        "winner": true
      }
    ],
    "votes": 994,
    "hasWinners": true
  },
  {
    "race": "City of Wagoner Prop 3 - Treasurer Appointment",
    "title": "City of Wagoner Proposition 3",
    "subheader": "Treasurer Appointment",
    "description": "",
    "precincts": 100,
    "precinctsTotal": 3,
    "precinctsReported": 3,
    "candidates": [{
        "candidatenum": 34001,
        "firstName": "",
        "lastName": "Yes",
        "party": "",
        "votes": 137,
        "incumbent": false,
        "winner": false
      },
      {
        "candidatenum": 34002,
        "firstName": "",
        "lastName": "No",
        "party": "",
        "votes": 859,
        "incumbent": false,
        "winner": true
      }
    ],
    "votes": 996,
    "hasWinners": true
  }
]

var zeros = 	[

      {

        "race": "Governor - Libertarian"
        ,"title": "Governor"
        ,"subheader": "Libertarian"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 1951
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 1001
                  ,"firstName": "CHRIS"
                  ,"lastName": "POWELL"

              ,"party": "L"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 1002
                  ,"firstName": "REX"
                  ,"lastName": "L LAWHORN"

              ,"party": "L"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Governor - Republican"
        ,"title": "Governor"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 1951
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 2001
                  ,"firstName": "MICK"
                  ,"lastName": "CORNETT"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 2002
                  ,"firstName": "KEVIN"
                  ,"lastName": "STITT"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Lieutenant Governor - Republican"
        ,"title": "Lieutenant Governor"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 1951
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 3001
                  ,"firstName": "DANA"
                  ,"lastName": "MURPHY"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 3002
                  ,"firstName": "MATT"
                  ,"lastName": "PINNELL"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "State Auditor - Republican"
        ,"title": "State Auditor"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 1951
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 4001
                  ,"firstName": "CINDY"
                  ,"lastName": "BYRD"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 4002
                  ,"firstName": "CHARLIE"
                  ,"lastName": "PRATER"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Attorney General - Republican"
        ,"title": "Attorney General"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 1951
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 5001
                  ,"firstName": "MIKE"
                  ,"lastName": "HUNTER"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 5002
                  ,"firstName": "GENTNER"
                  ,"lastName": "DRUMMOND"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Supt of Public Education - Republican"
        ,"title": "Supt of Public Education"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 1951
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 6001
                  ,"firstName": "JOY"
                  ,"lastName": "HOFMEISTER"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 6002
                  ,"firstName": "LINDA"
                  ,"lastName": "MURPHY"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Labor Commissioner - Republican"
        ,"title": "Labor Commissioner"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 1951
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 7001
                  ,"firstName": "CATHY"
                  ,"lastName": "COSTELLO"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 7002
                  ,"firstName": "LESLIE"
                  ,"lastName": "OSBORN"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Corporation Commissioner - Democrat"
        ,"title": "Corporation Commissioner"
        ,"subheader": "Democrat"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 1951
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 8001
                  ,"firstName": "ASHLEY"
                  ,"lastName": "NICOLE McCRAY"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 8002
                  ,"firstName": "BLAKE"
                  ,"lastName": "CUMMINGS"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Corporation Commissioner - Republican"
        ,"title": "Corporation Commissioner"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 1951
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 9001
                  ,"firstName": "BOB"
                  ,"lastName": "ANTHONY"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 9002
                  ,"firstName": "BRIAN"
                  ,"lastName": "BINGMAN"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "US House District 1 - Democrat"
        ,"title": "US House District 1"
        ,"subheader": "Democrat"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 326
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 10001
                  ,"firstName": "TIM"
                  ,"lastName": "GILPIN"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 10002
                  ,"firstName": "AMANDA"
                  ,"lastName": "DOUGLAS"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "US House District 1 - Republican"
        ,"title": "US House District 1"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 326
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 11001
                  ,"firstName": "TIM"
                  ,"lastName": "HARRIS"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 11002
                  ,"firstName": "KEVIN"
                  ,"lastName": "HERN"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "US House District 2 - Democrat"
        ,"title": "US House District 2"
        ,"subheader": "Democrat"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 522
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 12001
                  ,"firstName": "JASON"
                  ,"lastName": "NICHOLS"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 12002
                  ,"firstName": "CLAY"
                  ,"lastName": "PADGETT"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK Senate District 10 - Republican"
        ,"title": "OK Senate District 10"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 48
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 13001
                  ,"firstName": "BILL"
                  ,"lastName": "COLEMAN"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 13002
                  ,"firstName": "AMBER"
                  ,"lastName": "ROBERTS"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK Senate District 36 - Republican"
        ,"title": "OK Senate District 36"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 28
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 14001
                  ,"firstName": "JOHN"
                  ,"lastName": "HASTE"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 14002
                  ,"firstName": "BILL"
                  ,"lastName": "DAY"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK House District 10 - Republican"
        ,"title": "OK House District 10"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 26
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 15001
                  ,"firstName": "TRAVIS"
                  ,"lastName": "DUNLAP"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": true
            }

              ,

            {
              "candidatenum": 15002
                  ,"firstName": "JUDD"
                  ,"lastName": "STROM"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK House District 14 - Republican"
        ,"title": "OK House District 14"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 15
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 16001
                  ,"firstName": "GEORGE"
                  ,"lastName": "FAUGHT"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": true
            }

              ,

            {
              "candidatenum": 16002
                  ,"firstName": "CHRIS"
                  ,"lastName": "SNEED"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK House District 17 - Republican"
        ,"title": "OK House District 17"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 39
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 17001
                  ,"firstName": "JOSH"
                  ,"lastName": "HASS"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 17002
                  ,"firstName": "JIM"
                  ,"lastName": "GREGO"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK House District 30 - Republican"
        ,"title": "OK House District 30"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 17
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 18001
                  ,"firstName": "MARK"
                  ,"lastName": "LAWSON"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": true
            }

              ,

            {
              "candidatenum": 18002
                  ,"firstName": "KENT"
                  ,"lastName": "GLESENER"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK House District 36 - Republican"
        ,"title": "OK House District 36"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 19
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 19001
                  ,"firstName": "SEAN"
                  ,"lastName": "ROBERTS"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": true
            }

              ,

            {
              "candidatenum": 19002
                  ,"firstName": "LOUISE"
                  ,"lastName": "REDCORN"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK House District 66 - Republican"
        ,"title": "OK House District 66"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 16
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 20001
                  ,"firstName": "JADINE"
                  ,"lastName": "NOLLAN"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": true
            }

              ,

            {
              "candidatenum": 20002
                  ,"firstName": "BRIAN"
                  ,"lastName": "JACKSON"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK House District 68 - Democrat"
        ,"title": "OK House District 68"
        ,"subheader": "Democrat"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 13
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 21001
                  ,"firstName": "ANGELA"
                  ,"lastName": "STATUM"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 21002
                  ,"firstName": "MICHAEL"
                  ,"lastName": "ROSS"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK House District 68 - Republican"
        ,"title": "OK House District 68"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 13
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 22001
                  ,"firstName": "LONNIE"
                  ,"lastName": "SIMS"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 22002
                  ,"firstName": "NICOLE"
                  ,"lastName": "NIXON"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK House District 71 - Republican"
        ,"title": "OK House District 71"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 15
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 23001
                  ,"firstName": "CHERYL"
                  ,"lastName": "BABER"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 23002
                  ,"firstName": "BEVERLY"
                  ,"lastName": "A ATTEBERRY"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK House District 79 - Republican"
        ,"title": "OK House District 79"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 19
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 24001
                  ,"firstName": "KAREN"
                  ,"lastName": "GILBERT"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 24002
                  ,"firstName": "DAN"
                  ,"lastName": "HICKS"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK House District 80 - Republican"
        ,"title": "OK House District 80"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 18
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 25001
                  ,"firstName": "STAN"
                  ,"lastName": "MAY"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 25002
                  ,"firstName": "MIKE"
                  ,"lastName": "RITZE"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": true
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "OK House District 98 - Republican"
        ,"title": "OK House District 98"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 12
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 26001
                  ,"firstName": "LAURA"
                  ,"lastName": "STEELE"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 26002
                  ,"firstName": "DEAN"
                  ,"lastName": "F DAVIS"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Tulsa Co District Attorney - Republican"
        ,"title": "Tulsa County District Attorney"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 262
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 27001
                  ,"firstName": "STEVE"
                  ,"lastName": "KUNZWEILER"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 27002
                  ,"firstName": "BEN"
                  ,"lastName": "FU"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Tulsa Co Assessor - Republican"
        ,"title": "Tulsa County Assessor"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 262
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 28001
                  ,"firstName": "JOHN"
                  ,"lastName": "A WRIGHT"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 28002
                  ,"firstName": "DARREN"
                  ,"lastName": "GANTZ"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Tulsa Co Commissioner District 1 - Rep"
        ,"title": "Tulsa County Commissioner District 1"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 80
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 29001
                  ,"firstName": "STAN"
                  ,"lastName": "SALLEE"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 29002
                  ,"firstName": "TRACEY"
                  ,"lastName": "J WILSON"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Tulsa City Council District 1"
        ,"title": "Tulsa City Council"
        ,"subheader": "District 1"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 23
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 30001
                  ,"firstName": "JERRY"
                  ,"lastName": "GOODWIN"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 30002
                  ,"firstName": "VANESSA"
                  ,"lastName": "HALLHARPER"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 30003
                  ,"firstName": "LANA"
                  ,"lastName": "TURNER"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Tulsa City Council District 3"
        ,"title": "Tulsa City Council"
        ,"subheader": "District 3"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 27
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 31001
                  ,"firstName": "CHARLES"
                  ,"lastName": "WILKES"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 31002
                  ,"firstName": "JUSTIN"
                  ,"lastName": "ROLPH"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 31003
                  ,"firstName": "CRISTA"
                  ,"lastName": "PATRICK"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Tulsa City Council District 4"
        ,"title": "Tulsa City Council"
        ,"subheader": "District 4"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 22
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 32001
                  ,"firstName": "KARA"
                  ,"lastName": "JOY McKEE"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 32002
                  ,"firstName": "JUAN"
                  ,"lastName": "MIRET"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 32003
                  ,"firstName": "DANIEL"
                  ,"lastName": "REGAN"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 32004
                  ,"firstName": "BARBRA"
                  ,"lastName": "KINGSLEY"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Tulsa City Council District 5"
        ,"title": "Tulsa City Council"
        ,"subheader": "District 5"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 20
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 33001
                  ,"firstName": "ELIAH"
                  ,"lastName": "MISTHAVEN"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 33002
                  ,"firstName": "TY"
                  ,"lastName": "WALKER"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 33003
                  ,"firstName": "CASS"
                  ,"lastName": "FAHLER"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 33004
                  ,"firstName": "MYKEY"
                  ,"lastName": "ARTHRELL"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Tulsa City Council District 6"
        ,"title": "Tulsa City Council"
        ,"subheader": "District 6"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 19
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 34001
                  ,"firstName": "DEZERAY"
                  ,"lastName": "EDWARDS"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 34002
                  ,"firstName": "CONNIE"
                  ,"lastName": "DODSON"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Tulsa City Council District 9"
        ,"title": "Tulsa City Council"
        ,"subheader": "District 9"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 23
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 35001
                  ,"firstName": "BEN"
                  ,"lastName": "KIMBRO"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 35002
                  ,"firstName": "PAUL"
                  ,"lastName": "TAY"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Broken Arrow Prop 1 - Streets"
        ,"title": "City of Broken Arrow"
        ,"subheader": "Proposition 1"
        ,"description": "Bond for $142,625,000 in funding for constructing, reconstructing and repairing city streets"
        ,"precincts": 0
        ,"precinctsTotal": 46
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 36001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 36002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Broken Arrow Prop 2 - Public Safety"
        ,"title": "City of Broken Arrow"
        ,"subheader": "Proposition 2"
        ,"description": "Bond for $20,350,000 in funding for purchasing, constructing and repairing public safety utilities"
        ,"precincts": 0
        ,"precinctsTotal": 46
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 37001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 37002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Broken Arrow Prop 3 - Parks &amp; Rec"
        ,"title": "City of Broken Arrow"
        ,"subheader": "Proposition 3"
        ,"description": "Bond for $17,750,000 in funding for purchasing, constructing and repairing parks and recreation facilities"
        ,"precincts": 0
        ,"precinctsTotal": 46
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 38001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 38002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Broken Arrow Prop 4 - Public Buildings"
        ,"title": "City of Broken Arrow"
        ,"subheader": "Proposition 4"
        ,"description": "Bond for $16,800,000 in funding for purchasing land, and constructing and equipping public buildings"
        ,"precincts": 0
        ,"precinctsTotal": 46
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 39001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 39002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Broken Arrow Prop 5 - Stormwater"
        ,"title": "City of Broken Arrow"
        ,"subheader": "Proposition 5"
        ,"description": "Bond for $7,500,000 in funding for constructing, reconstructing and repairing stormwater facilities"
        ,"precincts": 0
        ,"precinctsTotal": 46
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 40001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 40002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Broken Arrow Prop 6 - Drainage"
        ,"title": "City of Broken Arrow"
        ,"subheader": "Proposition 6"
        ,"description": "Bond for $5,500,000 in funding for drainage improvements to property owned by the city"
        ,"precincts": 0
        ,"precinctsTotal": 46
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 41001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 41002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Adair Co Commissioner District 1 - Dem"
        ,"title": "Adair County Commissioner District 1"
        ,"subheader": "Democrat"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 6
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 42001
                  ,"firstName": "MIKE"
                  ,"lastName": "WININGER"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 42002
                  ,"firstName": "JIMMY"
                  ,"lastName": "CARL BAIRD"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Cherokee Co Commissioner District 3 - Dem"
        ,"title": "Cherokee County Commissioner District 3"
        ,"subheader": "Democrat"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 7
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 43001
                  ,"firstName": "CLIF"
                  ,"lastName": "HALL"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 43002
                  ,"firstName": "SCOTT"
                  ,"lastName": "KIRK"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Tahlequah Prop 1 - Hotel Tax"
        ,"title": "City of Tahlequah Proposition 1"
        ,"subheader": "Hotel Tax"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 7
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 44001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 44002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Tahlequah Prop 2 - Water/Sewage"
        ,"title": "City of Tahlequah Proposition 2"
        ,"subheader": "Water/Sewer Bond"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 7
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 45001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 45002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Town of Oaks Trustee (Unexpired Term)"
        ,"title": "Town of Oaks Trustee"
        ,"subheader": "(Unexpired Term)"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 2
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 46001
                  ,"firstName": "MAY"
                  ,"lastName": "COFFRON"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 46002
                  ,"firstName": "JESSE"
                  ,"lastName": "W REED"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Creek Co Assessor - Republican"
        ,"title": "Creek County Assessor"
        ,"subheader": "Republican"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 35
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 47001
                  ,"firstName": "JaNELL"
                  ,"lastName": "ENLOW"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 47002
                  ,"firstName": "DANIEL"
                  ,"lastName": "DELONG"

              ,"party": "R"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Grove Prop - Sales Tax Change"
        ,"title": "City of Grove Proposition"
        ,"subheader": "Sales Tax Change"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 5
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 48001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 48002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Jay Prop 1 - City Gov't Elections"
        ,"title": "City of Jay Proposition 1"
        ,"subheader": "City Government Elections"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 3
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 49001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 49002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Jay Prop 2 - PSO Franchise"
        ,"title": "City of Jay Proposition 2"
        ,"subheader": "PSO Franchise"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 3
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 50001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 50002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Town of Talihina Trustee (Unexpired Term)"
        ,"title": "Town of Talihina Trustee"
        ,"subheader": "(Unexpired Term)"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 2
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 51001
                  ,"firstName": "PAMELA"
                  ,"lastName": "LEWIS"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 51002
                  ,"firstName": "GARY"
                  ,"lastName": "JOHNSON"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 51003
                  ,"firstName": "NIKKI"
                  ,"lastName": "HIBDON"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Pocola Schools Prop - Construction"
        ,"title": "Pocola Schools Proposition"
        ,"subheader": "$665,000 Construction Bond"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 2
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 52001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 52002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Poteau Schools Prop - Construction"
        ,"title": "Poteau Schools Proposition"
        ,"subheader": "$14,950,000 Construction Bond"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 9
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 53001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 53002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Pryor Prop - City Charter Change"
        ,"title": "City of Pryor Proposition"
        ,"subheader": "City Charter Changes"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 5
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 54001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 54002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Paden School Board - Office 4"
        ,"title": "Paden School Board"
        ,"subheader": "Office 4 (Unexpired Term)"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 3
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 55001
                  ,"firstName": "JEREMIAH"
                  ,"lastName": "CASE"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 55002
                  ,"firstName": "KELLY"
                  ,"lastName": "JO SEATON"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Morris Prop 1 - Clerk/Treasurer Appt"
        ,"title": "City of Morris Proposition 1"
        ,"subheader": "Clerk/Treasurer Appointment"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 2
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 56001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 56002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "City of Morris Prop 2 - City Council Seat Reduction"
        ,"title": "City of Morris Proposition 2"
        ,"subheader": "City Council Seat Reduction"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 2
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 57001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 57002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Morris Schools Prop - Construction"
        ,"title": "Morris Schools Proposition"
        ,"subheader": "$4,685,000 Construction Bond"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 7
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 58001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 58002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "McCord Schools Prop - Construction"
        ,"title": "McCord Schools Proposition"
        ,"subheader": "$2,970,000 Construction Bond"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 2
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 59001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 59002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Yale Schools Prop 1 - Construction"
        ,"title": "Yale Schools Proposition 1"
        ,"subheader": "$605,000 Construction Bond"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 6
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 60001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 60002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Yale Schools Prop 2 - Transportation"
        ,"title": "Yale Schools Proposition 2"
        ,"subheader": "$45,000 Transportation Bond"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 6
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 61001
                  ,"firstName": ""
                  ,"lastName": "Yes"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 61002
                  ,"firstName": ""
                  ,"lastName": "No"

              ,"party": ""
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

        ,

      {

        "race": "Pittsburg Co Commissioner District 1 - Dem"
        ,"title": "Pittsburg County Commissioner District 1"
        ,"subheader": "Democrat"
        ,"description": ""
        ,"precincts": 0
        ,"precinctsTotal": 15
        ,"precinctsReported": 0
        ,"candidates":
        [

            {
              "candidatenum": 62001
                  ,"firstName": "CHARLIE"
                  ,"lastName": "W ROGERS"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

              ,

            {
              "candidatenum": 62002
                  ,"firstName": "MIKE"
                  ,"lastName": "GRIVETTE"

              ,"party": "D"
              ,"votes": 0
              ,"incumbent": false
            }

        ]
        ,"votes": 0
        ,"hasWinners": false
      }

  ]

export default races



// WEBPACK FOOTER //
// ./app/components/custom/ssr/TestData/election.js